import { useContext } from "react";

import IMapContext from "../types/IMapContext";

import MapContext from "./MapContext";

const useMap = (): IMapContext => useContext<IMapContext>(MapContext);

export default useMap;
